<template>
  <div class="amp_main">
    <div class="joint_con" v-loading="loading">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">作品拼接</span>
        <img
          src="../../assets/images/img2/offlogin.png"
          class="tools_off"
          @click="hide"
        />
      </div>
      <div class="joint_list">
        <div class="joint_mod" v-for="(item, index) in joint_list" :key="index">
          <!-- 插入停顿 -->
          <div class="joint_modl" v-if="item.type == 'pause'">
            <img src="../../assets/images/img2/stop.png" class="joint_icon" />
            <div>
              <p>
                <span>停顿</span>
                <span class="joint_s">{{ item.time }}秒</span>
              </p>
              <p class="joint_stop">
                <el-slider
                  v-model="item.time"
                  :min="1"
                  :max="10"
                  :step="0.5"
                ></el-slider>
              </p>
            </div>
          </div>
          <!-- 音效板块 -->
          <div class="joint_modl" v-if="item.type == 'sound'">
            <img
              src="../../assets/images/pause.png"
              class="joint_icon"
              @click="play_audio.play(item.url)"
              v-if="play_audio.audiourl == item.url"
            />
            <img
              class="joint_icon"
              src="../../assets/images//img2/joint_play.png"
              @click="play_audio.play(item.url)"
              v-else
            />
            <div>
              <p>{{ item.name }}</p>
              <p class="joint_mod_text">音效</p>
            </div>
          </div>
          <!-- 作品板块 -->
          <div
            class="joint_modl"
            v-if="item.type != 'sound' && item.type != 'pause'"
          >
            <img
              src="../../assets/images/pause.png"
              class="joint_icon"
              @click="play_audio.play(item.musicpath)"
              v-if="play_audio.audiourl == item.musicpath"
            />
            <img
              class="joint_icon"
              src="../../assets/images/play.png"
              @click.stop="play_audio.play(item.musicpath)"
              v-else
            />
            <div>
              <p>{{ item.wkname ? item.wkname : "未命名作品" }}</p>
              <p class="joint_mod_text">
                <span>{{ item.voiceauthor }}</span>
                <span>{{ item.bgname ? item.bgname : "无背景音" }}</span>
              </p>
            </div>
          </div>

          <div class="joint_modr">
            <!-- 上移 -->
            <img src="../../assets/images/img2/top.png" @click="up(index)" />
            <!-- 下移 -->
            <img
              src="../../assets/images/img2/top.png"
              class="joint_modr_bottom"
              @click="down(index)"
            />
            <!-- 移除 -->
            <img
              src="../../assets/images/img2/joint_off.png"
              @click="removeJoint(index)"
            />
          </div>
        </div>
        <!-- 拼接类型选择区域 -->
        <div class="joint_fun">
          <div class="joint_funli" @click="show_audiosel = true">
            <img src="../../assets/images/img2/joint_add.png" />
            <p>添加音频</p>
          </div>
          <div class="joint_funli" @click="show_sound = true">
            <img src="../../assets/images/img2/joint_xg.png" />
            <p>添加音效</p>
          </div>
          <div class="joint_funli" @click="addPause">
            <img src="../../assets/images/img2/joint_stopicon.png" />
            <p>添加停顿</p>
          </div>
        </div>
      </div>

      <div class="flex_bet_h">
        <div class="tools_btn" @click="concatAudio(false)" v-if="!play_state">
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>试听效果</span>
        </div>
        <div class="tools_btn" @click="stopPlay" v-else>
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>暂停播放</span>
        </div>
        <div class="tools_btn tools_btn2" @click="qryApiLimit(true)">
          <img
            src="../../assets/images/img2/exfile.png"
            class="tools_btn_icon"
          />
          <span>导出音频</span>
        </div>
      </div>
    </div>
    <div style="margin-left: 24px">
      <!-- 选择音频组件 -->
      <AudioSelect v-if="show_audiosel" @overSelect="addAudioList" />
    </div>
    <div style="margin-left: 24px">
      <!-- 音效选择组件 -->
      <SoundEffect v-if="show_sound" @overSelect="addSoundList" />
    </div>
  </div>
</template>
<script>
import AudioSelect from "./audio_select.vue";
import SoundEffect from "./sound_effect.vue";
import PlayListAudio from "../../utils/PlayListAudio.js";
export default {
  components: {
    AudioSelect,
    SoundEffect,
  },
  data() {
    return {
      value1: 5,
      show_audiosel: false, //作品选择组件显示状态
      show_sound: false, //音效选择组件显示状态
      joint_list: [], //拼接列表
      play_audio: new PlayListAudio(), //播放器对象
      audio: new Audio(), //播放器
      loading: false, //加载动画显示状态
      play_state: false, //播放状态
      time: null,
    };
  },
  methods: {
    // 查询接口调用次数
    qryApiLimit(isextend) {
      this.$globalFun.qryApiLimit(this,'3',()=>{
        this.concatAudio(isextend)
      })
    },
    // 停止播放
    stopPlay() {
      this.audio.pause();
      this.play_state = false;
    },
    // 监听播放状态
    monitorPlay() {
      let self = this;
      this.time = setInterval(() => {
        if (self.audio.ended) {
          self.play_state = false;
          clearInterval(self.time);
        }
      }, 1000);
    },
    // 拼接作品
    concatAudio(isextend) {
      // isextend？true=导出音频：false=试听效果
      let urlTemp = [];
      this.joint_list.forEach((item) => {
        if (item.type == "pause") {
          urlTemp.push(item.time);
        } else if (item.type == "sound") {
          urlTemp.push(item.url);
        } else {
          urlTemp.push(item.musicpath);
        }
      });
      let mp3urls = urlTemp.toString();
      if (!mp3urls) {
        this.$message({
          message: "拼接内容为空",
          type: "warning",
        });
        return;
      }
      let self = this;
      let url =
        self.$store.state.app_api + self.$store.state.app_url.ttsconcatapp;
      this.loading = true;
      this.$request.postHttp({ mp3urls: mp3urls }, url, (decData) => {
        self.loading = false;
        this.$globalFun.uptApiLimit(this,'3')
        let mp3url = decData.model.mp3url;
        if (isextend) {
          self.$globalFun.downloadDub(mp3url);
        } else {
          self.audio.src = mp3url;
          self.audio.play();
          self.play_state = true;
          self.monitorPlay();
        }
      });
    },
    // 作品上移
    up(i) {
      if (i == 0) return;
      let tempOption = this.joint_list[i - 1];
      this.$set(this.joint_list, i - 1, this.joint_list[i]);
      this.$set(this.joint_list, i, tempOption);
    },
    // 作品下移
    down(i) {
      if (i == this.joint_list.length - 1) return;
      let tempOption = this.joint_list[i + 1];
      this.$set(this.joint_list, i + 1, this.joint_list[i]);
      this.$set(this.joint_list, i, tempOption);
    },
    // 移除拼接元素
    removeJoint(index) {
      this.joint_list.splice(index, 1);
    },
    // 添加音效
    addSoundList(e) {
      this.show_sound = false;
      this.joint_list.push(...e);
      console.log(this.joint_list);
    },
    // 添加作品
    addAudioList(e) {
      this.show_audiosel = false;
      this.joint_list.push(...e);
    },
    // 添加停顿
    addPause() {
      let json = {
        time: 1,
        type: "pause",
      };
      this.joint_list.push(json);
    },
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style>
@import url("../../assets/css/tools.css");
</style>


// WEBPACK FOOTER //
// src/components/tools/joint.vue